import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';

@Component({
    selector: 'app-validate-epf-statement',
    templateUrl: './validate-epf-statement.component.html',
    styleUrls: ['./validate-epf-statement.component.scss'],
    standalone: false
})
export class ValidateEpfStatementComponent {
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);

  disableSubmit = false;
  file: File;

  validateEPFImage() {
    const xhr = this.restApi.postFileRequest(this.constructApi.getValidateEPFStatement(), this.file);
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status == 200) {
          this.disableSubmit = false;

          this.sharedService.openAlert("This EPF STATEMENT is a VALID statement", ALERT_TYPE.SUCCESS);
          this.file = undefined;

          this.reset();
        }
        else {
          this.disableSubmit = false;
          const json = JSON.parse(xhr.responseText);
          this.sharedService.openAlert(json.error, ALERT_TYPE.DANGER);
        }
      }
    };
  }

  handleFileInput(files: FileList) {
    this.disableSubmit = false;
    this.file = files.item(0);
  }

  reset() {
    this.activeModal.close();
  }
}
